var map = {
	"./allinc.png": 580,
	"./allinclusive.png": 8982,
	"./alpereiser.png": 9539,
	"./amisol.png": 3952,
	"./apollo.png": 3189,
	"./escapeaway.png": 6524,
	"./lionalpin.png": 6043,
	"./loveholidays.png": 7296,
	"./nazar.png": 2639,
	"./norwegianholidays.png": 5338,
	"./solfaktor.png": 5958,
	"./solia.png": 3381,
	"./soliadynamic.png": 876,
	"./test.png": 5635,
	"./ticket.png": 3663,
	"./tripx.png": 6030,
	"./tui.png": 5327,
	"./ving.png": 8649,
	"./vingdynamic.png": 5168,
	"./vitalreiser.png": 3861
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2596;